import { Divider as MuiDivider } from "@mui/material";

export function Divider(props) {
  const { margin = "0" } = props;

  return <MuiDivider style={{ margin }} />;
}
